import axios from 'axios';
import urlJoin from 'url-join';
import { CDN } from './static';
// TODO: import the dataVersion from somewher
// import { dataVersion } from '../../package.json';
const dataVersion = '0.3.0'

// TODO: Need to change to S3 when it's on prod
const isProd = process.env.NODE_NV === 'production';
const genUrl = (filePath) => {
    // const dataHost = isProd ? urlJoin(CDN, '/v2') : 'http://localhost:8080';
    const dataHost = urlJoin(CDN, '/v2');
    return urlJoin(dataHost, filePath);
};

function memoize(method) {
    const cache = {};

    return async (parameter) => {
        const args = JSON.stringify(parameter);
        cache[args] = cache[args] || await method(parameter);
        return cache[args];
    };
}

// eslint-disable-next-line import/prefer-default-export
export const fetchMonthly = memoize(async ({ system, yyyymm, filename }) => {
    try {
        const response = await axios.get(genUrl(`/${dataVersion}/${system}/${yyyymm}/${filename}`));
        return response.data;
    } catch (e) {
        console.log(`failed to fetch ${system} ${yyyymm} ${filename}`);
        console.log(e);
    }
});
